import api from './api';

export const getCategories = (includeInactive = false) =>
  api.get('/categories/', { params: { include_inactive: includeInactive } });

export const getCategory = (id) => api.get(`/categories/${id}`);

export const createCategory = (data) => api.post('/categories/', data);

export const updateCategory = (id, data) => api.put(`/categories/${id}`, data);

export const deleteCategory = (id) => api.delete(`/categories/${id}`);
